import {
  isEqual,
  // isPlainObject,
  isObjectLike,
  reduce,
  // diff,
} from 'lodash-es'
export const objectDiff = (a, b, path = '') =>
  reduce(
    a,
    function (result, value, key) {
      if (isObjectLike(value)) {
        if (isEqual(value, b[key])) {
          return result
        } else {
          return result.concat(objectDiff(value, b[key], path ? `${path}.${key}` : key))
        }
      } else {
        return isEqual(value, b[key]) ? result : result.concat(path ? `${path}.${key}` : key)
      }
    },
    [],
  )

// export const objectDiff = (obj1, obj2) => {
//   const diff = Object.keys(obj1).reduce((result, key) => {
//     if (!obj2.hasOwnProperty(key)) {
//       result.push(key)
//     } else if (isEqual(obj1[key], obj2[key])) {
//       const resultKeyIndex = result.indexOf(key)
//       result.splice(resultKeyIndex, 1)
//     }
//     return result
//   }, Object.keys(obj2))

//   return diff
// }

// export const objectDiff = function (obj1, obj2) {
//   return reduce(
//     obj1,
//     function (result, value, key) {
//       if (isPlainObject(value)) {
//         result[key] = diff(value, obj2[key])
//       } else if (!isEqual(value, obj2[key])) {
//         result[key] = value
//       }
//       return result
//     },
//     {},
//   )
// }
